//#region src/verticals/auth/AuthEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.LoginAttempted = "auth.login.attempted", e.LoginSucceeded = "auth.login.succeeded", e.LoginFailed = "auth.login.failed", e.SignupCompleted = "auth.signup.completed", e.LoggedOut = "auth.session.logged_out", e;
}({});
//#endregion
export { e as AuthEvent };
